import { captureError } from '@/shared/lib/errors/capture';

const REPORT_COOLDOWN_MS = 5 * 60 * 1000;
let lastReportedAt = 0;

/**
 * The signal-lost screen re-throws through `reset()` every ~30s for as long
 * as the outage lasts. One warning per 5 minutes per tab is enough to see the
 * user-facing blast radius in PostHog/Sentry; the rest is `signal: 'noise'`.
 */
export function reportUpstreamUnavailable(error: unknown, component: string): void {
  const now = Date.now();
  if (now - lastReportedAt < REPORT_COOLDOWN_MS) return;
  lastReportedAt = now;
  captureError(error, {
    component,
    action: 'upstream-unavailable',
    severity: 'warning',
    tags: { signal: 'noise' },
  });
}
